import React from 'react';
import ReactDOM from 'react-dom';
import App from 'App';
import { normalize } from 'styled-normalize'
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
${normalize}
	html {
		box-sizing: border-box;
		scroll-behavior: smooth;
		font-size: 62.5%; /*62.5% Me ayuda a resetear para los REMS */
	}

	*:focus {
		outline: 0 !important;
	}

	*,
	*:before,
	*:after {
		box-sizing: inherit;
	}

	body {
		font-family: 'Lato';
		font-style: normal;
		font-size: 1.4rem;
		line-height: 1.7rem;
		background: #ffffff;
		margin: 0;
		overflow-x: hidden;
	}

	/* =========================================================================
	   PRINT STYLES — imprime solo el contenido del formulario.

	   Convención: cualquier elemento con \`.no-print\` se oculta al imprimir.
	   Aplica a: Header, Hero, Footer, Breadcrumb, FormToolBar, ModalButtonClose,
	   y cualquier otro botón/control marcado explícitamente.

	   El form en sí se expande al ancho del papel, sin sombras ni colores de
	   fondo agresivos.
	   ========================================================================= */
	@media print {
		@page {
			size: A4;
			margin: 1.2cm;
		}

		/* Forzar que browsers impriman colores/bordes que normalmente skipea
		   para "ahorrar tinta" (necesario para que se vean los radios del cuestionario). */
		* {
			-webkit-print-color-adjust: exact !important;
			print-color-adjust: exact !important;
			color-adjust: exact !important;
		}

		html, body {
			background: #ffffff !important;
			overflow: visible !important;
			height: auto !important;
		}

		body {
			font-size: 11pt;
			line-height: 1.4;
			color: #000000;
		}

		/* Elementos marcados explícitamente como no imprimibles */
		.no-print {
			display: none !important;
		}

		/* Mejor break entre secciones largas del form */
		section, .print-keep-together {
			break-inside: avoid;
			page-break-inside: avoid;
		}

		h1, h2, h3 {
			break-after: avoid;
			page-break-after: avoid;
		}

		/* Links: mostrar URL al lado del texto */
		a[href]:after {
			content: " (" attr(href) ")";
			font-size: 90%;
			color: #555;
		}

		/* Form inputs: bordes finos en negro para que se vean al imprimir */
		input:not([type="radio"]):not([type="checkbox"]),
		select,
		textarea {
			border: 1px solid #888 !important;
			background: #ffffff !important;
			color: #000000 !important;
		}

		/* --- Form de postulación: sacar la decoración del wrapper --- */

		/* Container del form: sin shadow ni radius, fondo transparente */
		.form-section {
			box-shadow: none !important;
			border-radius: 0 !important;
			background: transparent !important;
			margin-bottom: 1rem !important;
			overflow: visible !important;
			width: 100% !important;
			max-width: 100% !important;
		}

		/* Forzar que ningún wrapper del form se extienda más allá de la página */
		.form-section,
		.form-section *,
		[class*="ComponentContainer"],
		[class*="BodyContainer"] {
			max-width: 100% !important;
			min-width: 0 !important;
		}

		/* Cabecera de la sección: en pantalla es el número, el título y una
		   línea de ayuda; en papel alcanza con el título en negro. */
		.form-section-header {
			display: block !important;
			background: transparent !important;
			height: auto !important;
			padding: 0 !important;
			margin: 0 0 1rem 0 !important;
			border-bottom: 1px solid #333 !important;
		}
		.form-section-header > span,
		.form-section-header > p {
			display: none !important;
		}
		.form-section-header h3 {
			color: #000 !important;
			text-align: left !important;
			margin: 0 !important;
			font-size: 14pt !important;
		}

		/* Zonas de carga (avatar y archivos adjuntos): son controles, no
		   aportan al papel. */
		.dropzone {
			display: none !important;
		}

		/* --- Cuestionario: radio buttons en 5 columnas fijas --- */

		/* Usamos display:grid (no flex) para forzar exactamente 5 columnas
		   iguales sin riesgo de que algún parent rompa el flex layout.
		   minmax(0, 1fr) permite que cada column se achique más allá de su
		   contenido natural, evitando overflow horizontal en página A4. */
		ul {
			display: grid !important;
			grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
			gap: 0.4rem !important;
			width: 100% !important;
			max-width: 100% !important;
			padding: 0 !important;
			margin: 0.5rem 0 !important;
			list-style: none !important;
			box-sizing: border-box !important;
		}

		/* Los wrappers de cada opción (Col styled). Sin flex-basis: el grid
		   los acomoda parejos. */
		ul > div {
			min-width: 0 !important;
			max-width: 100% !important;
			width: 100% !important;
			align-items: center !important;
			text-align: center !important;
		}

		/* Cada li (radio item) compacto */
		ul li {
			margin: 0.2rem 0 !important;
			padding: 0 !important;
			width: 100% !important;
		}

		/* Label de la opción: chiquito y centrado */
		ul li label {
			font-size: 9pt !important;
			line-height: 1.2 !important;
			height: auto !important;
			gap: 0.2rem;
			align-items: center !important;
		}

		/* El .check (círculo del radio): borde negro visible, más chico */
		ul li label .check,
		label .check {
			border: 1.5px solid #000 !important;
			background: transparent !important;
			width: 12px !important;
			height: 12px !important;
		}

		/* Radio seleccionado: dot interior negro pleno */
		ul li input[type="radio"]:checked + label .check::before,
		input[type="radio"]:checked + label .check::before {
			background: #000 !important;
		}

		/* Texto de la opción en negro */
		ul li label span,
		label span {
			color: #000 !important;
		}

		/* Reducir padding del Grid del form */
		[class*="Grid"], .form-body {
			padding: 0 !important;
		}

		/* Bloques marcados como no imprimibles dentro del formulario
		   (por ejemplo los datos del postulante). */
		.print-hide {
			display: none !important;
		}

		/* Filas del flexbox grid: full width */
		.row, [class*="Grid"], [class*="Row"] {
			max-width: 100% !important;
			margin-left: 0 !important;
			margin-right: 0 !important;
		}

		/* Inputs: más compactos en print */
		input:not([type="radio"]):not([type="checkbox"]) {
			padding: 4px 6px !important;
			height: auto !important;
			min-height: 20px !important;
		}

		/* Labels de los campos arriba: bold + compacto */
		label {
			font-weight: 600 !important;
			margin-bottom: 2px !important;
		}

		/* Evitar fondos pesados que gasten tinta */
		.print-strip-bg {
			background: transparent !important;
			box-shadow: none !important;
			border: none !important;
		}

		/* --- Datos de la postulación: vista compacta para impresión ---

		   Al papel van sólo los cinco campos marcados con la clase print-keep
		   en components/Form (Nombre del Proyecto, Empresa, Nombre, Apellido y
		   Email), en una fila de cinco columnas. El resto —Cargo, Provincia,
		   Localidad, Teléfono, Sitio Web, redes, confirmación de email y los
		   datos del postulante— no se imprime.

		   Antes esto colgaba del inline style del Grid (padding: 35px) y del
		   orden de los Cols; ahora se ancla en las clases que pone el propio
		   formulario, así reordenar un campo no rompe la impresión. */
		.form-section:first-of-type .form-body {
			display: grid !important;
			grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
			gap: 0.6rem !important;
			width: 100% !important;
			max-width: 100% !important;
		}

		/* Grupos, filas y wrappers que contienen un campo marcado: se disuelven
		   para que el campo caiga directo en la grilla de cinco columnas. */
		.form-section:first-of-type .form-body :has(.print-keep) {
			display: contents !important;
		}

		/* Todo lo demás de esa sección (títulos de grupo, campos no marcados,
		   avatar, checkbox del postulante) no llega al papel. */
		.form-section:first-of-type .form-body *:not(:has(.print-keep)):not(.print-keep):not(.print-keep *) {
			display: none !important;
		}
	}
`;

ReactDOM.render(
	<React.StrictMode>
		<GlobalStyle />
		<App />
	</React.StrictMode>,
	document.getElementById('root')
);
